const RBAC_USER_SELECTION_LOAD_ERROR_MESSAGE = 'No se pudieron cargar los usuarios'

export function parseRbacUsersPayload(payload) {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.users)) return payload.users
  return []
}

export function parseRbacUsersPagination(payload) {
  return payload?.pagination || {}
}

export function getRbacUsersLoadErrorMessage(error) {
  return error?.message || RBAC_USER_SELECTION_LOAD_ERROR_MESSAGE
}
